// Third-party scripts and browser extensions (Google Translate, ad blockers,
// password managers, etc.) can mutate the DOM behind React's back. When React
// later commits an update that removes or repositions a node it no longer
// owns, the browser throws "NotFoundError: Failed to execute 'removeChild' on
// 'Node'" and the whole tree crashes (facebook/react#11538, Sentry
// NOLAN-STUDIO-8). These guards make the affected DOM methods tolerant of
// externally moved nodes so a translated page degrades gracefully instead of
// taking the app down.

let installed = false

export const installDomSafetyPatches = () => {
  const NodeRef = typeof window !== 'undefined' ? window.Node : undefined
  if (installed || !NodeRef || !NodeRef.prototype) return
  installed = true

  const originalRemoveChild = NodeRef.prototype.removeChild
  NodeRef.prototype.removeChild = function removeChild (child) {
    if (child && child.parentNode !== this) {
      console.warn('domSafetyPatches: skipped removeChild for a node that is no longer a child of this parent (external DOM mutation)')
      return child
    }
    return originalRemoveChild.apply(this, arguments)
  }

  const originalInsertBefore = NodeRef.prototype.insertBefore
  NodeRef.prototype.insertBefore = function insertBefore (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      // The reference node was moved by an external script. Still attach the
      // new node (at the end of this parent) so React's tree stays mounted
      // and visible instead of being silently dropped.
      console.warn('domSafetyPatches: insertBefore reference node is no longer a child of this parent (external DOM mutation), appending instead')
      return this.appendChild(newNode)
    }
    return originalInsertBefore.apply(this, arguments)
  }
}
